import { IonCol, IonGrid, IonRow, IonSpinner } from "@ionic/react";
import { COUNTRYINFO } from "data/country";
import { digitChanger, numberWithCommas } from "helpers/helper";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function ProfitLossEmployee({
  profitLoss,
  employee,
  plLoading,
  employeeLoading,
  startTime,
  endOfTime,
}) {
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const { createUserData } = useSelector((state) => state.user);
  const navigate = useNavigate();
  return (
    <div className="purchase-summary relative">
      <IonGrid>
        <IonRow>
          <IonCol
            size="6"
            className="cursor-pointer"
            onClick={() =>
              navigate(
                `/total-profit-loss/?start=${startTime}&end=${endOfTime}`
              )
            }
          >
            <div className="text-center rounded-[10px] bg-white pr-[5px]">
              <p className="text-14 text-black font-bold mb-[8px]">
                {ekkLanguage.accounting.monthlyProfitLoss}
              </p>
              {!plLoading ? (
                <>
                  {profitLoss?.profit > 0 ? (
                    <h5 className="font-bold text-success text-18">
                      <span className="text-12">
                        {ekkLanguage.accounting.profit}{" "}
                      </span>
                      {profitLoss?.currency}
                      {profitLoss && numberWithCommas(profitLoss?.profit ?? 0.0)}
                    </h5>
                  ) : undefined}
                  {profitLoss?.loss > 0 ? (
                    <h5 className="font-bold text-primary text-18">
                      <span className="text-12">
                        {ekkLanguage.accounting.loss}{" "}
                      </span>
                      {profitLoss?.currency}
                      {profitLoss && numberWithCommas(profitLoss?.loss ?? 0.0)}
                    </h5>
                  ) : undefined}
                  {profitLoss?.loss == 0 && profitLoss?.profit == 0 ? (
                    <h5 className="font-bold text-black-1000 text-18">
                      <span className="text-12">
                        {ekkLanguage.accounting.loss}{" "}
                      </span>
                      {profitLoss?.currency}
                      {profitLoss && numberWithCommas(profitLoss?.loss ?? 0.0)}
                    </h5>
                  ) : undefined}
                </>
              ) : (
                <IonSpinner color="green"></IonSpinner>
              )}
            </div>
          </IonCol>
          <IonCol
            size="6"
            className="cursor-pointer"
            onClick={() =>
              navigate(`/total-employees/?start=${startTime}&end=${endOfTime}`)
            }
          >
            <div className="text-center rounded-[10px] bg-white pl-[5px]">
              <p className="text-14 text-primary font-bold mb-[8px]">
                Employees Salary
              </p>
              {!employeeLoading ? (
                <>
                  <p className="text-12 text-262626-1000 font-semibold mb-[8px]">
                    {digitChanger(employee?.count ?? 0)} Employee
                  </p>
                  <h5 className="font-bold text-262626-1000 text-18">
                    {employee?.currency}
                    {employee?.amount}
                  </h5>
                </>
              ) : (
                <IonSpinner color="red"></IonSpinner>
              )}
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
}
